module.exports = __webpack_public_path__ + "img/medicare.10e929d9.png";